module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAAAiBAMAAADCNbijAAAAD1BMVEUIBAQIBAQIBAQIBAT///+7fnaYAAAABXRSTlNAIP+AAL+xXWAAAAAqSURBVHgBYyAJCDAokQIMSFVuTApgYHAhBTgMMuWjykeVjyofVT6US2AA/KZoDieA098AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/hamburger_b.png
// module id = Ms1+
// module chunks = 1